/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { GradeFrequenceClassStudentViewModel } from "../types/GradeFrequenceClassStudentViewModel.ts";

export const gradeFrequenceClassStudentViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  name: z.string().nullish(),
}) as unknown as ToZod<GradeFrequenceClassStudentViewModel>;
